<template>
  <Modal
    v-model="showModal"
    :footer="false"
    :backdrop="true"
    :keyboard="false"
    :auto-focus="true"
    append-to-body>
    <template #header>
      <slot>
        <div class="flex items-center justify-between">
          <h3 class="m-0 text-xl leading-tight">
            <slot name="heading-text">Are you sure?</slot>
          </h3>

          <LinkDanger
            v-if="!hideCancelBtn"
            as="button"
            type="button"
            @click="cancel">
            Cancel
          </LinkDanger>
        </div>
      </slot>
    </template>

    <template #default>
      <div class="pb-4">
        <slot
          name="body"
          :confirm="confirm">
          <slot name="content" />

          <div class="mt-6 text-center">
            <component
              :is="button"
              @click="confirm"
              data-action="auto-focus">
              <slot name="confirm-text">Confirm</slot>
            </component>
          </div>
        </slot>
      </div>
    </template>
  </Modal>
</template>

<script>
import { Modal } from 'uiv';
import ButtonDanger from '@/components/buttons/ButtonDanger.vue';
import ButtonPrimary from '@/components/buttons/ButtonPrimary.vue';
import LinkDanger from '@/components/links/LinkDanger.vue';

export default {
  components: {
    LinkDanger,
    Modal,
  },

  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },

    dangerButton: {
      type: Boolean,
      default: true,
    },

    hideCancelBtn: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'cancel', 'confirm'],
  data() {
    return {
      isConfirmed: false,
    };
  },

  computed: {
    showModal: {
      get() {
        return this.modelValue;
      },
      set(newVal) {
        this.$emit('update:modalValue', newVal);
      },
    },

    button() {
      return this.dangerButton ? ButtonDanger : ButtonPrimary;
    },
  },

  methods: {
    cancel() {
      this.$emit('update:modelValue', false);
      this.$emit('cancel');
    },

    confirm() {
      this.$emit('update:modelValue', false);
      this.$emit('confirm');
    },
  },
};
</script>
